import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
const initialState = {
  showChequeListGrid: false,
  showFileDetailsInfo: false,
  saveBtnDisable: false,
  screenMode: "",
  securityChequeInitialStateAfterFilter: {},
  filterValues: {
    branchArray: [],
    branch: null,
    applicationArray: [],
    applicationNum: null,
    customerId: "",
    receiptDate: new Date(dayjs(new Date()).format("MM/DD/YYYY")),
    blockNumber: null,
    blockNumberArray: [],
    repayApp: "",
    repayMode: "",
    repaymentType: null,
    repaymentTypeArray: [],
    sanctionedDate: null,
    capacity: null,
    capacityArray: [],
    ecdDate: null,
    losStatus: "",
    sanctionAmt: "",
    tenure: "",
    rateOfInterest: "",
  },
  chequeDetailsInfo: {},
  chequeDetailData: {
    id: "",
    addRecord: false,
    deleteCheckValue: false,
    startChequeNumber: "",
    startChequeDate: null,
    noOfCheque: "",
    chequeType: null,
    chequeTypeArray: [],
    micrType: null,
    micrTypeArray: ["MICR"],
    micrNumber: "",
    bankOption: null,
    bankOptionArray: [],
    drawerBank: null,
    drawerBankArray: [],
    drawerBankMap: [],
    drawerBranch: null,
    drawerBranchArray: [],
    drawerBranchMap: [],
    ifsc: "",
    accNumber: "",
    accHolderName: "",
    repayAmt: "0",
    chequeAmt: "0",
    chequeStatus: "",
    chequeStatusArray: [],
  },
  chequeGridRows: [],
  fileDetailsData: {
    applicationNum: "",
    emiStartDate: null,
    fbdDay: null,
    emiDueDate: null,
    emiAmt: "0",
  },
  touchHandler: {
    branchTouched: false,
    applicationNumTouched: false,
    receiptDateTouched: false,
    blockNumberTouched: false,
    receiptDateTouched: false,
    repayAppTouched: false,
    repayModeTouched: false,
    repaymentTypeTouched: false,
    capacityTouched: false,

    // Cheque Info data below
    startChequeNumberTouched: false,
    startChequeDateTouched: false,
    noOfChequeTouched: false,
    chequeTypeTouched: false,
    micrTypeTouched: false,
    micrNumberTouched: false,
    bankOptionTouched: false,
    drawerBankTouched: false,
    drawerBranchTouched: false,
    ifscTouched: false,
    accNumberTouched: false,
    accHolderNameTouched: false,
    repayAmtTouched: false,
    chequeAmtTouched: false,
  },
  valueIsValid: {
    branchIsValid: false,
    applicationNumIsValid: false,
    receiptDateIsValid: false,
    blockNumberIsValid: false,
    receiptDateIsValid: false,
    repayAppIsValid: false,
    repayModeIsValid: false,
    repaymentTypeIsValid: false,
    capacityIsValid: false,

    // Cheque Info data below
    startChequeNumberIsValid: false,
    startChequeDateIsValid: false,
    noOfChequeIsValid: false,
    chequeTypeIsValid: false,
    micrTypeIsValid: false,
    micrNumberIsValid: false,
    bankOptionIsValid: false,
    drawerBankIsValid: false,
    drawerBranchIsValid: false,
    ifscIsValid: false,
    accNumberIsValid: false,
    accHolderNameIsValid: false,
    repayAmtIsValid: false,
    chequeAmtIsValid: false,
  },
  securityPdcLovData: {
    targetFields: [],
    lovDataValue: {},
  },
};
const SecurityChequeReducer = createSlice({
  name: "securityCheque",
  initialState: initialState,
  reducers: {
    updateLovTargetFields(state, action) {
      state.securityPdcLovData.targetFields = action.payload;
    },
    updateLovDataValue(state, action) {
      state.securityPdcLovData.lovDataValue = action.payload;
    },
    updateSecurityChequeInitialStateAfterFilter(state, action) {
      state.securityChequeInitialStateAfterFilter = action.payload;
    },
    updateScreenMode(state, action) {
      state.screenMode = action.payload;
    },
    updateChequeDetailsInfo(state, action) {
      state.chequeDetailsInfo = action.payload;
    },
    resetChequeDetailsInfo(state, action) {
      state.chequeDetailsInfo = {};
    },
    resetChequeListGridRows(state, action) {
      state.chequeGridRows = [];
    },
    updateSaveBtnDisable(state, action) {
      state.saveBtnDisable = action.payload;
    },
    updateShowChequeListGrid(state, action) {
      state.showChequeListGrid = action.payload;
    },
    updateShowFileDetailsInfo(state, action) {
      state.showFileDetailsInfo = action.payload;
    },
    updateChequeListGridRows(state, action) {
      state.chequeGridRows = action.payload;
    },
    updateBranchArray(state, action) {
      state.filterValues.branchArray = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterValues.branch = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateApplicationArray(state, action) {
      state.filterValues.applicationArray = action.payload;
    },
    updateApplicationValue(state, action) {
      state.filterValues.applicationNum = action.payload;
      state.valueIsValid.applicationNumIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateBlockNumberArray(state, action) {
      state.filterValues.blockNumberArray = action.payload;
    },
    updateBlockNumberValue(state, action) {
      state.filterValues.blockNumber = action.payload;
      state.valueIsValid.blockNumberIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateRepaymentTypeArray(state, action) {
      state.filterValues.repaymentTypeArray = action.payload;
    },
    updateRepaymentTypeValue(state, action) {
      state.filterValues.repaymentType = action.payload;
      state.valueIsValid.repaymentTypeIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateCapacityArray(state, action) {
      state.filterValues.capacityArray = action.payload;
    },
    updateCapacityValue(state, action) {
      state.filterValues.capacity = action.payload;
      state.valueIsValid.capacityIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateReceiptDate(state, action) {
      state.filterValues.receiptDate = action.payload;
      state.valueIsValid.receiptDateIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateStartChequeNumber(state, action) {
      state.chequeDetailData.startChequeNumber = action.payload;
      state.valueIsValid.startChequeNumberIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        String(action.payload).length === 6 &&
        Number(action.payload) > 0 &&
        !String(action.payload).includes(".");
    },
    updateStartChequeNumberIsValid(state, action) {
      state.valueIsValid.startChequeNumberIsValid = action.payload;
    },

    updateNumberOfCheques(state, action) {
      state.chequeDetailData.noOfCheque = action.payload;
      state.valueIsValid.noOfChequeIsValid =
        action.payload !== "" &&
        action.payload !== "0" &&
        action.payload !== null &&
        action.payload !== undefined &&
        Number(action.payload) !== 0 &&
        Number(action.payload) > 0 &&
        Number(action.payload.length) < 3 &&
        !String(action.payload).includes(".");
    },

    updateChequeType(state, action) {
      state.chequeDetailData.chequeType = action.payload;
      state.valueIsValid.chequeTypeIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateChequeTypeArray(state, action) {
      state.chequeDetailData.chequeTypeArray = action.payload;
    },

    updateDraweerBanksArray(state, action) {
      state.chequeDetailData.drawerBankArray = action.payload;
    },

    updateDraweerBanksMap(state, action) {
      state.chequeDetailData.drawerBankMap = action.payload;
    },

    updateDraweeBranchArray(state, action) {
      state.chequeDetailData.drawerBranchArray = action.payload;
    },

    updateDraweeBranchMap(state, action) {
      state.chequeDetailData.drawerBranchMap = action.payload;
    },

    updateMICRTypeValue(state, action) {
      state.chequeDetailData.micrType = action.payload;
      state.valueIsValid.micrTypeIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateBankOptionArray(state, action) {
      state.chequeDetailData.bankOptionArray = action.payload;
    },

    updateBankOptionValue(state, action) {
      state.chequeDetailData.bankOption = action.payload;
      state.valueIsValid.bankOptionIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateMICRValue(state, action) {
      state.chequeDetailData.micrNumber = action.payload;
      state.valueIsValid.micrNumberIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        String(action.payload).length === 9 &&
        /^\d+$/.test(action.payload) &&
        Number(action.payload) > 0 &&
        !String(action.payload).includes(".");
      // checking that MICR should contain only 9 digit number.
    },

    updateDraweeBankValue(state, action) {
      state.chequeDetailData.drawerBank = action.payload;
      state.valueIsValid.drawerBankIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateDraweeBranchValue(state, action) {
      state.chequeDetailData.drawerBranch = action.payload;
      state.valueIsValid.drawerBranchIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateIFSCValue(state, action) {
      state.chequeDetailData.ifsc = action.payload;
      state.valueIsValid.ifscIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        /^[A-Za-z0-9]*$/.test(action.payload) &&
        String(action.payload).length === 11;
    },

    updateAccountNumValue(state, action) {
      state.chequeDetailData.accNumber = action.payload;
      state.valueIsValid.accNumberIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        String(action.payload).length <= 18 &&
        String(action.payload).length >= 9 &&
        Number(action.payload) > 0 &&
        !String(action.payload).includes(".");
    },

    updateAccountHolderNameValue(state, action) {
      state.chequeDetailData.accHolderName = action.payload;
      state.valueIsValid.accHolderNameIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        /^[A-Za-z\s]*$/.test(action.payload);
    },

    updateRepayAmt(state, action) {
      state.chequeDetailData.repayAmt = action.payload;
      state.valueIsValid.repayAmtIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    updateChequeAmt(state, action) {
      state.chequeDetailData.chequeAmt = action.payload;
      state.valueIsValid.chequeAmtIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    //Reducer for touch handler
    updateBranchIsTouched(state, action) {
      state.touchHandler.branchTouched = action.payload;
    },
    updateApplicationNumberIsTouched(state, action) {
      state.touchHandler.applicationNumTouched = action.payload;
    },
    updateBlockNumberIsTouched(state, action) {
      state.touchHandler.blockNumberTouched = action.payload;
    },
    updateReceiptDateIsTouched(state, action) {
      state.touchHandler.receiptDateTouched = action.payload;
    },
    updateRepaymentTypeIsTouched(state, action) {
      state.touchHandler.repaymentTypeTouched = action.payload;
    },
    updateCapacityIsTouched(state, action) {
      state.touchHandler.capacityTouched = action.payload;
    },

    updateStartChequeNumberErrorHandler(state, action) {
      state.touchHandler.startChequeNumberTouched = action.payload;
    },

    updateNumOfChequesErrorHandler(state, action) {
      state.touchHandler.noOfChequeTouched = action.payload;
    },

    updateChequeTypeIsTouched(state, action) {
      state.touchHandler.chequeTypeTouched = action.payload;
    },
    updateMICRTypeIsTouched(state, action) {
      state.touchHandler.micrTypeTouched = action.payload;
    },
    updateBankOptionIsTouched(state, action) {
      state.touchHandler.bankOptionTouched = action.payload;
    },
    updateMICRTouched(state, action) {
      state.touchHandler.micrNumberTouched = action.payload;
    },

    updateDraweeBankIsTouched(state, action) {
      state.touchHandler.drawerBankTouched = action.payload;
    },

    updateDraweeBranchIsTouched(state, action) {
      state.touchHandler.drawerBranchTouched = action.payload;
    },

    updateIFSCIsTouched(state, action) {
      state.touchHandler.ifscTouched = action.payload;
    },
    updateAccountNumIsTouched(state, action) {
      state.touchHandler.accNumberTouched = action.payload;
    },

    updateAccountHolderNameIsTouched(state, action) {
      state.touchHandler.accHolderNameTouched = action.payload;
    },

    updateRepayAmtTouchHandler(state, action) {
      state.touchHandler.repayAmtTouched = action.payload;
    },

    updateChequeAmtTouchHandler(state, action) {
      state.touchHandler.chequeAmtTouched = action.payload;
    },
    resetFilterValues(state, action) {
      state.filterValues.branch = null;
      state.filterValues.applicationArray = [];
      state.filterValues.applicationNum = null;
      state.filterValues.customerId = "";
      state.filterValues.receiptDate = new Date(
        dayjs(new Date()).format("MM/DD/YYYY")
      );
      state.filterValues.repayApp = "";
      state.filterValues.repayMode = "";
      state.filterValues.repaymentType = null;
      state.filterValues.sanctionedDate = null;
      state.filterValues.ecdDate = null;
      state.filterValues.blockNumber = null;
      state.filterValues.blockNumberArray = [];
      state.filterValues.capacity = null;
      state.filterValues.losStatus = "";
      state.filterValues.sanctionAmt = "";
      state.filterValues.tenure = "";
      state.filterValues.rateOfInterest = "";
    },
    updateFilterValues(state, action) {
      state.filterValues.branch = action.payload.branch;
      state.filterValues.applicationNum = action.payload.applicationNum;
      state.filterValues.customerId = action.payload.customerId;
      state.filterValues.repayApp = action.payload.repayApp;
      state.filterValues.repayMode = action.payload.repayMode;
      state.filterValues.sanctionedDate = action.payload.sanctionedDate;
      state.filterValues.ecdDate = action.payload.ecdDate;
      state.filterValues.losStatus = action.payload.losStatus;
      state.filterValues.sanctionAmt = action.payload.sanctionAmt;
      state.filterValues.tenure = action.payload.tenure;
      state.filterValues.rateOfInterest = action.payload.rateOfInterest;
    },
    updateFileDetailsData(state, action) {
      state.fileDetailsData.applicationNum = action.payload.applicationNum;
      state.fileDetailsData.emiStartDate = action.payload.emiStartDate;
      state.fileDetailsData.emiDueDate = action.payload.emiDueDate;
      state.fileDetailsData.fbdDay = action.payload.fbdDay;
      state.fileDetailsData.emiAmt = action.payload.emiAmt;
    },
    updateChequeDetailData(state, action) {
      state.chequeDetailData.startChequeNumber =
        action.payload.startChequeNumber;
      state.chequeDetailData.startChequeDate = action.payload.startChequeDate;
      state.chequeDetailData.noOfCheque = action.payload.noOfCheque;
      state.chequeDetailData.chequeType = action.payload.chequeType;
      state.chequeDetailData.micrType = action.payload.micrType;
      state.chequeDetailData.bankOption = action.payload.bankOption;
      state.chequeDetailData.micrNumber = action.payload.micrNumber;
      state.chequeDetailData.drawerBank = action.payload.drawerBank;
      state.chequeDetailData.drawerBranch = action.payload.drawerBranch;
      state.chequeDetailData.ifsc = action.payload.ifsc;
      state.chequeDetailData.accNumber = action.payload.accNumber;
      state.chequeDetailData.accHolderName = action.payload.accHolderName;
      state.chequeDetailData.repayAmt = action.payload.repayAmt;
      state.chequeDetailData.chequeAmt = action.payload.chequeAmt;
    },
    resetFileDetailsData(state, action) {
      state.fileDetailsData.applicationNum = "";
      state.fileDetailsData.emiStartDate = null;
      state.fileDetailsData.emiDueDate = null;
      state.fileDetailsData.fbdDay = null;
      state.fileDetailsData.emiAmt = "0";
    },
    resetAllTouchHandlers(state, action) {
      state.touchHandler = initialState.touchHandler;
      // since all gets reset so reset the valueIsValid also.
      state.valueIsValid = initialState.valueIsValid;
    },
    resetChequeDetailValues(state, action) {
      state.chequeDetailData.startChequeNumber = "";
      state.chequeDetailData.startChequeDate = null;
      state.chequeDetailData.noOfCheque = 0;
      state.chequeDetailData.chequeType = "";
      state.chequeDetailData.micrType = "";
      state.chequeDetailData.bankOption = "";
      state.chequeDetailData.micrNumber = "";
      state.chequeDetailData.drawerBank = "";
      state.chequeDetailData.drawerBranch = "";
      state.chequeDetailData.ifsc = "";
      state.chequeDetailData.accNumber = "";
      state.chequeDetailData.accHolderName = "";
      state.chequeDetailData.repayAmt = "0";
      state.chequeDetailData.chequeAmt = "0";

      state.touchHandler.startChequeNumberTouched = false;
      state.touchHandler.startChequeDateTouched = false;
      state.touchHandler.noOfChequeTouched = false;
      state.touchHandler.chequeTypeTouched = false;
      state.touchHandler.micrTypeTouched = false;
      state.touchHandler.bankOptionTouched = false;
      state.touchHandler.micrNumberTouched = false;
      state.touchHandler.drawerBankTouched = false;
      state.touchHandler.drawerBranchTouched = false;
      state.touchHandler.ifscTouched = false;
      state.touchHandler.accNumberTouched = false;
      state.touchHandler.accHolderNameTouched = false;
      state.touchHandler.repayAmtTouched = false;
      state.touchHandler.chequeAmtTouched = false;

      state.valueIsValid.startChequeNumberIsValid = false;
      state.valueIsValid.startChequeDateIsValid = false;
      state.valueIsValid.noOfChequeIsValid = false;
      state.valueIsValid.chequeTypeIsValid = false;
      state.valueIsValid.micrTypeIsValid = false;
      state.valueIsValid.bankOptionIsValid = false;
      state.valueIsValid.micrNumberIsValid = false;
      state.valueIsValid.drawerBankIsValid = false;
      state.valueIsValid.drawerBranchIsValid = false;
      state.valueIsValid.ifscIsValid = false;
      state.valueIsValid.accNumberIsValid = false;
      state.valueIsValid.accHolderNameIsValid = false;
      state.valueIsValid.repayAmtIsValid = false;
      state.valueIsValid.chequeAmtIsValid = false;
    },
  },
});
export const SecurityChequeReducerAction = SecurityChequeReducer.actions;
export default SecurityChequeReducer.reducer;
